export default { 
  apiKey: "AIzaSyCVekJf39sEaVVtZjF8zbwr2YdEEY-ctis",
  authDomain: "myshop-572e3.firebaseapp.com",
  databaseURL: "https://myshop-572e3.firebaseio.com",
  projectId: "myshop-572e3",
  storageBucket: "myshop-572e3.appspot.com",
  messagingSenderId: "529369247032"
}


// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js